module.exports = __webpack_public_path__ + "img/mostlysunny.6aa64d43.png";